import { useCallback, useEffect, useState } from 'react';
import { API } from '../io/Api';

const usePhoneCall = () => {
    const [callSid, setCallSid] = useState('');
    const [status, setStatus] = useState('');
    const dial = useCallback(async (target: string, params: Record<string, string>) => {
        const call = await API.call(target, params);
        setCallSid(call.sid);
        setStatus(call.status);
    }, []);

    useEffect(() => {
        if (callSid !== '') {
            const interval = setInterval(async () => {
                const status = (await API.checkCall(callSid));
                setStatus(status);
                if (status === 'ended') {
                    setCallSid('');
                    setStatus('');
                }
            }, 3000);
            return () => { clearInterval(interval) };
        }
    }, [callSid]);

    const hangup = useCallback(async () => {
        await API.finishCall(callSid);
        // setCallSid('');
        // setStatus('');
    }, [callSid]);
    return { dial, hangup, status };
}

export default usePhoneCall;